import React from 'react'
import classNames from 'classnames'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import HorizontalLine from 'src/components/Elements/HorizontalLine'
import { toTitleCase } from 'src/utils/helpers/StringHelper'
import programStyles from '../programStyles.module.scss'

const CarouselCard = ({
  carouselKey,
  imageUrl,
  blockTitle,
  slideTitle,
  slideBody
}) => {
  return (
    <div key={carouselKey} className={generalStyles.mb20} data-testid={carouselKey} >
      <div className={programStyles.carouselCardContainer}>
        <div className={programStyles.header}>
          <div className={generalStyles.mr20}>
            <img className={programStyles.image} src={imageUrl} />
          </div>
          <div className={generalStyles.flexColumn}>
            <div className={generalStyles.mb0}>
              <span className={fontStyles.pxsmallboldlsssinneutral08onyxgartnersans12pt} data-testid='expectBlockHeader'>
                {toTitleCase(blockTitle)}
              </span>
            </div>
            <span className={fontStyles.h5lsgartnersans20pt} data-testid='expectBlockTitle'>
              {slideTitle}
            </span>
          </div>
        </div>
        <div className={classNames(generalStyles.mt10, generalStyles.mb10)}>
          <HorizontalLine color={'white'} fullWidth={true} />
        </div>
        <span className={fontStyles.psmalllsneutral08onyxgartnersans15pt} data-testid='expectBlockBody'>{slideBody}</span>
      </div>
    </div>
  )
}

export default CarouselCard
